import { useTranslation } from "@coworker/locales";
import { useCustomAllSelectOption } from "../../shared/filters/utils/useAllSelectOption";
import {
  FilterType,
  FilterValue,
  InputType,
  SelectFilter,
  StringFilterValue,
} from "../../shared/filters/types/filter";
import { TASK_TYPE_ID, QUANTITY_TYPE_ID } from "../constants/filterIds";
import { useTaskTypeFilterConfig } from "./useTaskTypeFilterConfig";
import useFlag, { FLAGS } from "@coworker/app/src/hooks/useFlag";

export function useQuantityTypeFilter(
  filterValues: FilterValue[]
): SelectFilter {
  const { t } = useTranslation();
  const enableAddonOrdersV2 = useFlag(FLAGS.ENABLE_ADDON_ORDERS_V2);
  const defaultValue = { filterId: QUANTITY_TYPE_ID, value: "" };
  const { hasConfig, config } = useTaskTypeFilterConfig(
    QUANTITY_TYPE_ID,
    filterValues
  );

  let enabled: boolean;

  if (hasConfig) {
    // Config found - use it (takes precedence)
    enabled = config !== null;
  } else {
    // No config found - use existing logic unchanged
    const taskTypeValue = filterValues.find(
      ({ filterId }) => filterId === TASK_TYPE_ID
    );
    const taskTypeValueValue =
      (taskTypeValue as StringFilterValue)?.value ?? "";

    // Support both v1 (pickAndRefill, refill) and v2 (addonOrder) task types
    const addonTaskTypes = enableAddonOrdersV2
      ? ["addonOrder"]
      : ["pickAndRefill", "refill"];
    enabled = addonTaskTypes.includes(taskTypeValueValue);
  }

  return useCustomAllSelectOption(
    {
      inputType: InputType.Select,
      filterType: FilterType.Filter,
      id: QUANTITY_TYPE_ID,
      title: t("quantity_typeString"),
      options: [
        {
          value: "PIECES",
          title: t("piecesString"),
          dependsOnFilterId: TASK_TYPE_ID,
        },
        {
          value: "MULTI_PACK",
          title: t("multipackString"),
          dependsOnFilterId: TASK_TYPE_ID,
        },
        {
          value: "PALLET",
          title: t("palletString"),
          dependsOnFilterId: TASK_TYPE_ID,
        },
      ],
      enabled,
      defaultValue,
    },
    t("allQuantityTypesString")
  );
}
